import apiClient from '../../Services/ApiClient';
import React, { useState } from 'react';
import Loading from '../Loading';
import { useEffectAsync } from '../../helpers';
import { USER_RELATIONS } from '../UserInfo/UserData';
import { useAppContext } from '../../Services/AppContext';
import PatientUserRelation from './PatientUserRelation';
import PatientUserRelationAdd from './PatientUserRelationAdd';
import FirstUpper from '../FirstUpper';
import v2styles from '../PatientProfile/PatientProfileV2.module.scss';
import { useLazyPatientUserRelationsQuery } from '../../graphql/graphql';

interface Props {
	userId: string;
	v2template: boolean;
	userRelations?: any[];
}

const PatientUserRelations: React.FC<Props> = ({
	userId,
	v2template = false,
	userRelations: defaultUserRelations = false,
}) => {
	const [userRelations, setUserRelations] = useState(defaultUserRelations);
	const [adding, setAdding] = useState(false);
	const { translation } = useAppContext();
	const [getPatientUserRelations, { isLoading }] =
		useLazyPatientUserRelationsQuery();

	// @ts-ignore
	const handleRemove = async id => {
		await apiClient.delete('/user-relations/' + id);
		await loadData();
	};

	// @ts-ignore
	const handleReload = async () => {
		await loadData();
		setAdding(false);
	};

	// @ts-ignore
	useEffectAsync(async () => {
		if (!defaultUserRelations) {
			await loadData();
		}
	}, []);

	// @ts-ignore
	const loadData = async () => {
		let result;
		if (userId) {
			result = await getPatientUserRelations({
				userId,
			}).unwrap();
		}
		const relations = result?.user?.userRelations || [];
		setUserRelations(relations);
	};

	if (userRelations === false) {
		return (
			<div className={'py-5'}>
				<Loading />
			</div>
		);
	}

	if (v2template) {
		return (
			<div className={v2styles.doctors}>
				<div className={v2styles.title}>
					<FirstUpper>
						{translation['doctor.patientCardScreen.doctors']}
					</FirstUpper>
				</div>
				{userRelations &&
					userRelations.map(item => {
						if ([3, 4, 8].includes(item.type)) {
							return (
								<PatientUserRelation
									key={item.id}
									userRelation={item}
									handleRemove={handleRemove}
									v2template={true}
								/>
							);
						}
					})}
				{adding && (
					<PatientUserRelationAdd
						userId={userId}
						handleReload={handleReload}
						v2template={true}
					/>
				)}
				{!adding && (
					<a
						onClick={() => setAdding(true)}
						className='patient-profile__panel__content__attending-doctors__add-button'>
						<FirstUpper>
							{
								translation[
									'component.patientProfile.addNextAmbualnceAndDoctor'
								]
							}
						</FirstUpper>
					</a>
				)}
			</div>
		);
	}

	return (
		<div className='patient-profile__panel__content__attending-doctors'>
			<div className='patient-profile__panel__content__attending-doctors__title'>
				{translation['doctor.patientCardScreen.doctors']}
			</div>
			{userRelations.map(userRelation => (
				<PatientUserRelation
					key={userRelation.id}
					userRelation={userRelation}
					handleRemove={handleRemove}
				/>
			))}
			{adding && (
				<PatientUserRelationAdd userId={userId} handleReload={handleReload} />
			)}
			{!adding && (
				<a
					onClick={() => setAdding(true)}
					className='patient-profile__panel__content__attending-doctors__add-button'>
					<FirstUpper>
						{translation['component.patientProfile.addNextAmbualnceAndDoctor']}
					</FirstUpper>
				</a>
			)}
		</div>
	);
};

export default PatientUserRelations;
